import { Component, OnInit, ViewChild } from '@angular/core';
// import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {User} from '../User';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
//import { AlertService } from '../alert.service';
import {AuthenticationService} from '../authentication.service';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { HeaderComponent } from '../header/header.component';
import { UserService } from '../user.service';
import { AlertService } from '../alert.service';

@Component({
  selector: 'app-login-signup',
  templateUrl: './login-signup.component.html',
  styleUrls: ['./login-signup.component.scss']
})
export class LoginSignupComponent implements OnInit {
  isDivVisible: boolean = true;
  buttonText:string;
  model: any = {};
    loading = false;
    returnUrl: string;

    myForm: FormGroup;
  usernameCtrl: FormControl;
  passwordCtrl: FormControl;

  private gender: null;

  private user:User;
  username:string;
  password:string;

  show1: boolean = false;
  show2:boolean =true;
 
  public show: boolean = true;
  public buttonName: any = 'Sign Up';
  private URL_Link='https://api.on-track.in/api/';
  private url: string = 'https://api.on-track.in/api/customer';
 private posturl='https://api.on-track.in/api/signup';
 private posturl1='https://api.on-track.in/api/authenticate';
 private posturl2='https://api.on-track.in/api/verifyOtp';

 loginAlert:string;
  loginError:boolean=false;

  //userTxt = false;
  //basicModal:boolean=true;
  //returnUrl: string;

  toggle() {
    this.show1 = !this.show1;
  }

  toggleH() {
    this.show = !this.show;

    // CHANGE THE NAME OF THE BUTTON.
    if (this.show)
      this.buttonName = "Sign Up";
    else
      this.buttonName = "Login";
  }
  
  constructor(private httpClient:HttpClient,private route: ActivatedRoute,private router: Router,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,private authenticationservice:AuthenticationService,
    private alertService: AlertService
    )
        {  }
        public data:any=[];
        saveInLocal(key, val): void {
          //console.log('recieved= key:' + key + 'value:' + val);
          this.storage.set(key, val);
          this.data[key]= this.storage.get(key);
        }
        
        getFromLocal(key): string {
          //console.log('recieved= key:' + key);
          return this.data[key]= this.storage.get(key);
          //console.log(this.data);
          //return this.data;
        }
        
  ngOnInit() {
            
    this.user = new User({
      fname:"",lName:"",
        email:"", password:"" , 
        gender:""});
     

        
               
  }
  public custnm = this.getFromLocal('Name');
  public onFormSubmit({ value, valid}: { value: User, valid: boolean }) {
    //this.logout();
    this.user = value;
    console.log( this.user);
    console.log("valid: " + valid);
    this.httpClient.post(this.posturl ,this.user)
    .subscribe(
      (data:any) => {
        console.log(data);
      }
    )
    //this.dialogRef.close();
   
}

public onFormLogin({ value, valid}: { value: User, valid: boolean }):Observable<any> {
 
  this.user = value;
  console.log( this.user);
  console.log("valid: " + valid);
  this.httpClient.post(this.posturl1 ,this.user)
  .subscribe((data:any) =>{
       if(data.success){
      let customerObject = data.customer;
      let customerIddd = customerObject.id;
      let customerName = customerObject.fName;
      console.log("Customer id : " + customerIddd);
      console.log("Customer Name : " + customerName);
      this.storage.set('custDD',customerIddd);
      this.storage.set('Name',customerName);
      this.buttonText = customerName;
      this.router.navigate(['/model']);
      this.refresh();
     
      
    }else{
      //console.log("Login failed");
      this.success("Login failed");
    }
    this.buttonText="Hi"+this.custnm; 
    
  });
 
  //console.log("Successfully logged in");
  this.success("Successfully logged in");
  //btnText:'Logout';
  return this.httpClient.get(this.url);
  
 
 
}


refresh(): void {
  window.location.reload();
}

// logout() {
//    this.storage.remove('custDD');
//   this.saveInLocal('custDD',null);
//   this.router.navigate(['/model']);
//   this.show2 = !this.show2;
//   this.dialogRef.close();
// }

verifyOTP(value)
{
   let jsonData = 
   {"mobile":value.mobile,
   "otp":value.otp}
  this.httpClient.post(this.posturl2 ,jsonData)
  .subscribe(
    (data:any) => {
      console.log(data);
      
    }
  )
}


email:string;
resetPwd(emailVal:string)
{
 emailVal=this.email;
 //console.log("Hello",emailVal);
 
   let getResetData = {"email":emailVal};
   //console.log(getResetData);
  
this.httpClient.post(this.URL_Link + 'resetPassword' ,getResetData)
.subscribe(
(reset:any) =>{
//console.log( reset)
}
)
//this.success("Link sent successfully");
}



success(message: string) { 
  this.alertService.success(message);
}

error(message: string) {
  this.alertService.error(message);
}

info(message: string) {
  this.alertService.info(message);
}

warn(message: string) {
  this.alertService.warn(message);
}

clear() {
  this.alertService.clear();
}

}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/login-signup/login-signup.component.ts